import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import {ItemsProps} from "../../Data/Items/Items";
import {Cart} from "../../Components/Cart/Cart";
import React from "react";

interface ProductsSliderProps {
    title: string;
    items: ItemsProps[];
}

const ProductsSlider: React.FC<ProductsSliderProps> = (props) => {
    const {
        title,
        items,
    } = props
    return (
        <section className={"pt-9 max-lg:pt-4"}>
            <h2 className={'text-xl font-semibold max-md:text-base'}>
                {title}
            </h2>

            <div>
                <Swiper
                    breakpoints={{
                        0: {
                            slidesPerView: 2,
                        },
                        425: {
                            slidesPerView: 3,
                        },
                        767: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 6,
                        },
                    }}
                    style={{
                        "--swiper-navigation-size": "16px",
                    }}
                    spaceBetween={2}
                    navigation={true}
                    modules={[Navigation]}
                    className="mt-3.5"
                >
                    <div>
                        {
                            items.length
                                ?
                                items?.map((items) => (
                                    <SwiperSlide key={items.id}>
                                        <Cart item={items} />
                                    </SwiperSlide>
                                ))
                                : null}
                    </div>

                </Swiper>
            </div>
        </section>
    )
}

export default ProductsSlider;
